module.exports = __webpack_public_path__ + "img/find_clue.df7145ec.png";